import * as React from 'react'
import { Redirect, RouteComponentProps, Route, RouteProps } from 'react-router-dom';
import { ROUTE_NAMES } from '@bakbak/common';
import { withAppContext, AppContextProps } from '../context/AppContext';

// export class AuthC extends React.PureComponent<ChildProps<RouteProps & IMeQuery, MeQuery> & AppContextProps> {
// 	renderRoute = (routeProps: RouteComponentProps<{}>) => {
// 		const { loggedUser, meLoading, component } = this.props;
// 		let pathname = '';
// 		if (this.props.location) {
// 			pathname = this.props.location.pathname;
// 		}
// 		if (meLoading) {
// 			return <div>...loading</div>;
// 		} else if (!meLoading && !loggedUser) {
// 			this.props.context.updateLoggedUser(null);
// 			return <Redirect to={{ pathname: ROUTE_NAMES.LOGIN, state: { next: pathname } }} />;
// 		} else {
// 			const Component = component as any;
// 			this.props.context.updateLoggedUser(loggedUser);
// 			return <Component {...routeProps} />
// 		}
// 	}
// 	render() {
// 		const { component, loggedUser, meLoading, ...rest } = this.props;
// 		return <Route {...rest} render={this.renderRoute} />;
// 	}
// }

export class AuthC extends React.PureComponent<RouteProps & AppContextProps> {
	renderRoute = (routeProps: RouteComponentProps<{}>) => {
		const { context, component } = this.props;
		let pathname = '';
		if (this.props.location) {
			pathname = this.props.location.pathname;
		}
		if (context.loggedUser === undefined) {
			return null;
		} else if (context.loggedUser === null) {
			return <Redirect to={{ pathname: ROUTE_NAMES.LOGIN, state: { next: pathname } }} />;
		} else {
			const Component = component as any;
			return <Component {...routeProps} />
		}
	}
	render() {
		const { component, ...rest } = this.props;
		return <Route {...rest} render={this.renderRoute} />;
	}
}

export const AuthRoute = withAppContext(AuthC);


// WEBPACK FOOTER //
// ./src/routes/AuthRoute.tsx